import Service from "../../../Services/index";

const SheetImport = {
    namespaced: true,
    state: {
        table: [],
        replace_data: [],
        dataPaginate: {
            current_page: 1,
            from: 1,
            last_page: 1,
            per_page: 1,
            total: 1,
            to: 1
        }
    },
    mutations: {
        GET_SHEET: (state, res) => {
            state.table = res.data;
            state.dataPaginate = {
                current_page: res.current_page,
                from: res.form,
                last_page: res.last_page,
                per_page: res.per_page,
                total: res.total,
                to: res.to
            };
        },
        REPLACE_SHEET: (state, res) => {
            state.replace_data = res;
        }
    },
    actions: {
        get({commit}, page = 1) {
            return Service.ImportSheet.getImportSheet(page)
                .then(response => {
                    commit("GET_SHEET", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        show({commit}, id) {
            return Service.ImportSheet.showImportSheet(id)
                .then(response => {
                    commit("REPLACE_SHEET", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        create({commit}, data) {
            return Service.ImportSheet.createImportSheet(data)
                .then(response => {
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        update({commit}, {id, data}) {
            return Service.ImportSheet.updateImportSheet(id, data)
                .then(() => {
                    //console.log("update success");
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        delete({commit}, id) {
            return Service.ImportSheet.deleteImportSheet(id)
                .then(() => {
                    //console.log("delete success");
                })
                .catch(err => {
                    //console.log(err);
                });
        },
        search({commit}, {page = "", code, date}) {
            return Service.ImportSheet.searchImportSheet(page, code, date)
                .then(response => {
                    commit("GET_SHEET", response);
                })
                .catch(err => {
                    //console.log(err);
                });
        }
    }
};

export default SheetImport;
